import { Navigate } from "react-router-dom";

import useFCSubscriptionStore from "@hsl/fc-subscription/store";

import { FlowStepper } from "./FlowStepper";

export const WatchFlow = () => {
    const user = useFCSubscriptionStore((store) => store.user);

    if (user) {
        // call api immediately
        return <Navigate to="/my-funds" replace />;
    } else {
        return (
            <FlowStepper
                steps={["select-funds", "add-details", "verify-email"]}
                defaultStep="add-details"
                type="watch"
            />
        );
    }
};
